export function dataInRequest(params = {}) {
  return {
    type: '@auditoriaParametros/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@auditoriaParametros/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@auditoriaParametros/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@auditoriaParametros/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@auditoriaParametros/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@auditoriaParametros/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@auditoriaParametros/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@auditoriaParametros/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@auditoriaParametros/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@auditoriaParametros/RECORD_FILTERING',
    payload: { params },
  };
}
